import LimitedCompanyFormValidation from './LimitedCompanyFormValidation';
import SoleTraderFormValidation from './SoleTraderFormValidation';

export const validateCompanyForm = (company, fieldValues) => {
    if (company.companyType.value === 'sole_trader') {
        return SoleTraderFormValidation(fieldValues);
    } else {
        return LimitedCompanyFormValidation(fieldValues);
    }
};
